import { getAlternativeTextCardReason } from '@wix/a11y-rules';
import { convertBooleanStatusToElementStatus } from '../../../components/fixers/alt-image-fixer/utils';
const getGlobalSectionElementStatus = globalSectionElementState => {
  const updatedStatus = convertBooleanStatusToElementStatus(!!(globalSectionElementState != null && globalSectionElementState.isDecorative) || !!(globalSectionElementState != null && globalSectionElementState.alt) && getAlternativeTextCardReason(globalSectionElementState.alt) === undefined);
  return updatedStatus;
};
export const getUpdatedAltTextImagesFromState = (baseImages, stateMap, globalSectionStateMap) => {
  if (stateMap === undefined && globalSectionStateMap === undefined) {
    return baseImages;
  }
  const updatedImages = [];
  baseImages.forEach(baseImage => {
    const componentId = baseImage.componentId ?? baseImage.id;
    const globalSectionElementState = globalSectionStateMap == null ? void 0 : globalSectionStateMap.get(componentId);
    const hasGlobalAltTextChange = (globalSectionElementState == null ? void 0 : globalSectionElementState.alt) !== undefined || (globalSectionElementState == null ? void 0 : globalSectionElementState.isDecorative) !== undefined;
    const imageState = stateMap == null ? void 0 : stateMap.get(baseImage.id);
    if (imageState !== undefined || globalSectionElementState !== undefined) {
      const mergedAlt = (globalSectionElementState == null ? void 0 : globalSectionElementState.alt) ?? (imageState == null ? void 0 : imageState.alt) ?? baseImage.alt;
      const isLinked = !!baseImage.isLinked;
      const updatedImage = {
        ...baseImage,
        alt: mergedAlt,
        isDecorative: (globalSectionElementState == null ? void 0 : globalSectionElementState.isDecorative) ?? (imageState == null ? void 0 : imageState.isDecorative) ?? baseImage.isDecorative,
        status: isLinked ? convertBooleanStatusToElementStatus(!!mergedAlt && getAlternativeTextCardReason(mergedAlt) === undefined) : hasGlobalAltTextChange ? getGlobalSectionElementStatus(globalSectionElementState) : (imageState == null ? void 0 : imageState.status) ?? baseImage.status
      };
      updatedImages.push(updatedImage);
    } else {
      updatedImages.push(baseImage);
    }
  });
  return updatedImages;
};
//# sourceMappingURL=get-updated-alt-text-images-from-state.js.map